import {useFormatCurrency} from '@aboutyou/i18n';
import React from 'react';
import {DoubleRangeInput} from '../../../../atoms/DoubleRangeInput/DoubleRangeInput';

interface Props {
  max: number;
  min: number;
  onApply: (range: [number, number]) => void;
  onChange: (range: [number, number]) => void;
  values: [number, number];
  className?: string;
  currencyCode: string;
}

export const PriceRangeInput: React.FC<Props> = ({
  max,
  min,
  values,
  onApply,
  onChange,
  className,
  currencyCode,
}) => {
  const formatCurrency = useFormatCurrency();

  return (
    <DoubleRangeInput
      max={max}
      min={min}
      onApply={({adjustRange, values}) => {
        if (!adjustRange) {
          onApply(values);
        }
      }}
      onChange={({values}) => {
        onChange(values);
      }}
      scale={max - min < 100000 ? 'linear' : 'log'}
      transformLabel={value =>
        formatCurrency(value, currencyCode, {withoutDecimal: true})
      }
      values={values}
      className={className}
      step={100}
    />
  );
};
